/**
 * @see https://wiki.x2sy.com/display/RS/BR+Mobile+Web+-+Placeholders+in+Player
 * @see https://wiki.x2sy.com/pages/viewpage.action?pageId=393445
 */

/**
 * объект не доступен на устройстве (Apple, SmartTV, etc)
 * @type {string}
 */
const BIZ_CLASS = 'BIZ_CLASS';

const CATCH_UP_IS_UNAVAILABLE = 'CATCH_UP_IS_UNAVAILABLE';

/**
 * контракт партнера для данного ключа не позволяет воспроизвести видео
 * @type {string}
 */
const CONTRACT = 'CONTRACT';

/**
 * выключен 3d content на ключе
 * @type {string}
 */
const D3_IS_NOT_SUPPORTED = 'D3_IS_NOT_SUPPORTED';

/**
 * выключен показ HDR контента на ключе
 * @type {string}
 */
const HDR_IS_NOT_SUPPORTED = 'HDR_IS_NOT_SUPPORTED';
const INVALID_VIRTUAL_OBJECT_ID = 'INVALID_VIRTUAL_OBJECT_ID';

/**
 *  у объекта нет указанного bitrate
 * @type {string}
 */
const NO_BITRATE = 'NO_BITRATE';

/**
 * доступность запрошенного качества для видео невозможно проверить, поскольку не задан контракт для видео
 * @type {string}
 */
const NO_CONTRACT = 'NO_CONTRACT';
/**
 * выключен DRM на ключе
 * @type {string}
 */
const NO_DRM_SUPPORT = 'NO_DRM_SUPPORT';

const NO_VIRTUAL_OBJECT = 'NO_VIRTUAL_OBJECT';
const NO_VOD_COUNTRY = 'NO_VOD_COUNTRY';
const NOT_EMBEDDED = 'NOT_EMBEDDED';
const NOT_ENABLED_IN_COUNTRY = 'NOT_ENABLED_IN_COUNTRY';
const NOT_PURCHASABLE = 'NOT_PURCHASABLE';
/**
 * текущий партнер отключен
 * @type {string}
 */
const PARTNER_IS_DISABLED = 'PARTNER_IS_DISABLED';

const SUBSCRIPTION_NOT_ACTIVATED = 'SUBSCRIPTION_NOT_ACTIVATED';

/**
 * запрошенное качество не соответствует доступному по подписке
 * @type {string}
 */
const BITRATE_DISABLED_BY_PURCHASED_SUBSCRIPTION = 'BITRATE_DISABLED_BY_PURCHASED_SUBSCRIPTION';

/**
 * выключен показ 4K контента на ключе
 * @type {string}
 */
const UHD_IS_NOT_SUPPORTED = 'UHD_IS_NOT_SUPPORTED';

const LICENSE_RESTRICTION = new Set([
  PARTNER_IS_DISABLED,
  NO_CONTRACT,
  BIZ_CLASS,
]);

const GEO_RESTRICTIONS = new Set([
  NOT_ENABLED_IN_COUNTRY,
  NO_VOD_COUNTRY,
]);

/*
const ALL_RESTRICTIONS = new Set([
  BIZ_CLASS,
  CATCH_UP_IS_UNAVAILABLE,
  CONTRACT,
  D3_IS_NOT_SUPPORTED,
  HDR_IS_NOT_SUPPORTED,
  INVALID_VIRTUAL_OBJECT_ID,
  NO_BITRATE,
  NO_CONTRACT,
  NO_DRM_SUPPORT,
  NO_VIRTUAL_OBJECT,
  NO_VOD_COUNTRY,
  NOT_EMBEDDED,
  NOT_ENABLED_IN_COUNTRY,
  NOT_PURCHASABLE,
  PARTNER_IS_DISABLED,
  SUBSCRIPTION_NOT_ACTIVATED,
  UHD_IS_NOT_SUPPORTED,
]);
*/

export {
  BITRATE_DISABLED_BY_PURCHASED_SUBSCRIPTION,
  LICENSE_RESTRICTION,
  GEO_RESTRICTIONS,
  BIZ_CLASS,
  CATCH_UP_IS_UNAVAILABLE,
  CONTRACT,
  D3_IS_NOT_SUPPORTED,
  HDR_IS_NOT_SUPPORTED,
  INVALID_VIRTUAL_OBJECT_ID,
  NO_BITRATE,
  NO_CONTRACT,
  NO_DRM_SUPPORT,
  NO_VIRTUAL_OBJECT,
  NO_VOD_COUNTRY,
  NOT_EMBEDDED,
  NOT_ENABLED_IN_COUNTRY,
  NOT_PURCHASABLE,
  PARTNER_IS_DISABLED,
  SUBSCRIPTION_NOT_ACTIVATED,
  UHD_IS_NOT_SUPPORTED,
};
